export default {"src":"/_next/static/media/Blog.6773b3f3.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};